import React from 'react';
import { Star, Quote } from 'lucide-react';

const testimonials = [
  {
    name: "Encik Razali B.",
    role: "Penjawat Awam, Kuching",
    initial: "R",
    rating: 5,
    color: "from-emerald-500 to-emerald-700",
    quote: "Komitmen saya dah lebih 70% sebelum ni. Selepas semakan dengan team Aiman Consultant, saya dapat selesaikan komitmen lama dan kini lebih lega. Highly recommended!"
  },
  {
    name: "Puan Siti A.",
    role: "Guru, Sibu",
    initial: "S",
    rating: 5,
    color: "from-amber-500 to-amber-700",
    quote: "Proses sangat mudah dan pantas. Hanya 2 minit isi maklumat, terus dapat consultation di WhatsApp. Maklumat saya betul-betul dirahsiakan. Terima kasih!"
  },
  {
    name: "Sjn. Ahmad B.",
    role: "Polis Diraja Malaysia, Miri",
    initial: "A",
    rating: 5,
    color: "from-emerald-600 to-emerald-800",
    quote: "Khidmat pelanggan sangat mesra dan professional. Mereka explain semua pilihan tanpa pressure. Saya dapat susun komitmen ikut kemampuan saya."
  }
];

const TestimonialsSection = () => {
  return (
    <section className="py-12 sm:py-16 bg-gradient-to-b from-white to-emerald-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          {/* Title */}
          <div className="text-center mb-10 sm:mb-12">
            <div className="inline-flex items-center justify-center gap-1 mb-3">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="h-5 w-5 sm:h-6 sm:w-6 fill-amber-500 text-amber-500" />
              ))}
            </div>
            <h2 className="text-2xl sm:text-3xl lg:text-5xl font-bold text-emerald-900 mb-3">
              Apa Kata Pelanggan Kami
            </h2>
            <p className="text-emerald-700 text-sm sm:text-base">
              Ratusan penjawat awam di Sarawak telah memilih kami
            </p>
          </div>

          {/* Testimonials Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8">
            {testimonials.map((testimonial, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl shadow-xl p-6 sm:p-8 border-t-4 border-amber-500 hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 relative"
              >
                {/* Quote Icon */}
                <div className="absolute top-4 right-4 opacity-10">
                  <Quote className="h-12 w-12 text-emerald-900" />
                </div>

                {/* Rating */}
                <div className="flex gap-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="h-4 w-4 fill-amber-500 text-amber-500" />
                  ))}
                </div>

                {/* Quote */}
                <p className="text-emerald-800 text-sm sm:text-base leading-relaxed mb-6 italic">
                  "{testimonial.quote}"
                </p>

                {/* Author */}
                <div className="flex items-center gap-4 pt-4 border-t border-emerald-100">
                  <div className={`w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-gradient-to-br ${testimonial.color} flex items-center justify-center text-white font-bold text-xl shadow-md`}>
                    {testimonial.initial}
                  </div>
                  <div>
                    <p className="font-bold text-emerald-900 text-sm sm:text-base">{testimonial.name}</p>
                    <p className="text-emerald-600 text-xs sm:text-sm">{testimonial.role}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Disclaimer */}
          <p className="text-center text-emerald-600 text-xs mt-8 italic">
            * Testimoni disunting untuk privasi. Hubungi kami untuk dapatkan rujukan sebenar.
          </p>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
